<form novalidate #motorsEndingDatetimeSectionForm="ngForm">
  @if (draftLoaded$ | async) {
    <tg-row class="motors-listing-details-page__section">
      <tg-col sm="12" lg="4">
        <tm-date name="endDate" inputReadonly [required]="true" [hideOptionalLabel]="true" label="Choose an end date" dateFormat="MM/yyyy/dd"
                (dateChange)="updateEndDate($event)" [minDate]="minDate" [maxDate]="maxDate()" [selectedDate]="
                            draftData.listingDetails.endDate
                        " [validation]="
                        validation.listingDetails.endDate | toValidator
                    "
        [disabled]="inputDisabled"></tm-date>
      </tg-col>
      <tg-col sm="12" lg="4">
        <tg-select-container required label="Choose an end time"
          class="motors-listing-details-page__section__end-time-container">
          <select tgSelect name="auctionTime" required (change)="publish()" (change)="auctionTimeChange()"
            [(ngModel)]="draftData.listingDetails.endTime" [validation]="auctionTimeValidation()" [disabled]="inputDisabled" >
            <option [ngValue]="null" selected></option>
            @for (o of metadata.auctionTimes; track o) {
              <option [ngValue]="o.value">
                {{ o.display }}
              </option>
            }
          </select>
        </tg-select-container>
        <p class="motors-listing-details-page__section__end-time-text">Trade Me's busiest time is 7:00-10:00 pm, every day except Saturday</p>
      </tg-col>
    </tg-row>
  }
</form>